class BoxSelector extends HTMLElement {
  connectedCallback() {
    this.maxSelection = parseInt(this.dataset.maxSelection, 10) || 5;
    this.checkboxes = Array.from(this.querySelectorAll('[data-ref="box-checkbox"]'));
    this.counterEl = this.querySelector('[data-ref="counter"]');
    this.hiddenContainer = this.querySelector('[data-ref="hidden-inputs-container"]');
    this.productForm = this.closest('form[action*="/cart/add"]');

    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => this.handleChange());
    });

    this.updateUI();
  }

  handleChange() {
    const selected = this.checkboxes.filter((c) => c.checked);

    if (selected.length > this.maxSelection) {
      const lastChanged = event.target;
      lastChanged.checked = false;
      return;
    }

    this.updateUI();
  }

  updateUI() {
    const selected = this.checkboxes.filter((c) => c.checked);
    const count = selected.length;

    if (this.counterEl) {
      const suffix = this.counterEl.textContent.split('/')[1]?.trim().replace(/^\d+\s*/, '') || '';
      this.counterEl.textContent = `${count} / ${this.maxSelection} ${suffix}`;
    }

    const limitReached = count >= this.maxSelection;
    this.checkboxes.forEach((checkbox) => {
      const item = checkbox.closest('[data-ref="box-item"]');
      item.classList.toggle('box-selector__item--selected', checkbox.checked);
      item.classList.toggle('box-selector__item--disabled', limitReached && !checkbox.checked);
      checkbox.disabled = limitReached && !checkbox.checked;
    });

    this.syncHiddenInputs(selected);
  }

  syncHiddenInputs(selected) {
    if (!this.hiddenContainer) return;
    this.hiddenContainer.innerHTML = '';

    selected.forEach((checkbox, index) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[Choix ${index + 1}]`;
      input.value = checkbox.dataset.productTitle;
      this.hiddenContainer.appendChild(input);
    });
  }
}

customElements.define('box-selector', BoxSelector);